package me.tbsten.compose.preview.lab.gallery.previewlist

import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import me.tbsten.compose.preview.lab.ui.PreviewLabTheme
import me.tbsten.compose.preview.lab.ui.components.PreviewLabText
import me.tbsten.compose.preview.lab.ui.components.textfield.PreviewLabTextField

@Composable
internal fun SearchBar(query: String, onQueryChange: (String) -> Unit, modifier: Modifier = Modifier) {
    val textStyle = PreviewLabTheme.typography.body3
    PreviewLabTextField(
        value = query,
        onValueChange = onQueryChange,
        placeholder = { PreviewLabText("Search @Preview", style = textStyle) },
        textStyle = textStyle,
        modifier = modifier
            .padding(4.dp),
    )
}
